import {createApp} from 'vue';
import { createRouter, createWebHistory } from 'vue-router'

// Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       redirect: '/login'
//     },
//     {
//       path: '/login', 
//       name: 'login',
//       component: () => import(/* webpackChunkName: "about" */ '../views/Longin'),
//       meta: {keepAlive: true}
//     },
//     {
//       path: '/handover',
//       name: 'handover',
//       component: () => import(/* webpackChunkName: "about" */ '../views/Handover')
//     }
//   ]
// })

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Longin')
  },
  {
    path: '/handover',
    name: 'handover',
    component: () => import(/* webpackChunkName: "about" */ '../views/Handover')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
